import React from 'react';

import Segmented, { SegmentedOption } from 'components/DesignSystem/Segmented';
import { MeteorologyViewMode } from 'redux/reducers/meteorologyFieldsObservedDataControlPanelReducer';

import './index.scss';

const SpatialIcon = (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinejoin="round"
  >
    <path d="M9 4 3 6v14l6-2 6 2 6-2V4l-6 2-6-2z" />
    <path d="M9 4v14M15 6v14" />
  </svg>
);

const HeatmapIcon = (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
  >
    <path d="M3 9h18M3 15h18M9 3v18M15 3v18" />
  </svg>
);

export interface ModeSwitchProps {
  value: MeteorologyViewMode;
  onChange: (next: MeteorologyViewMode) => void;
  heatmapDisabled?: boolean;
}

export default function ModeSwitch({
  value,
  onChange,
  heatmapDisabled = false,
}: ModeSwitchProps) {
  const options: SegmentedOption<MeteorologyViewMode>[] = [
    { value: 'spatial', label: 'Espacial', iconNode: SpatialIcon },
    {
      value: 'heatmap', label: 'Heatmap', iconNode: HeatmapIcon, disabled: heatmapDisabled,
    },
  ];

  return (
    <Segmented
      className="observed-data-mode-switch"
      options={options}
      value={value}
      onChange={onChange}
    />
  );
}
